import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

interface IProps {
  logo?: string;
  children?: JSX.Element | JSX.Element[];
}

const ApplicationBar = ({ logo, children }: IProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [isMobile, setMobile] = useState(true);
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    !isBelowMd && isMobile ? setMobile(false) : setMobile(true);
  }, [isBelowMd]);

  return (
    <div className="AppBar flex items-start border-b-[0.0625rem] bg-gray-50 border-[color:#cacaca] z-50 dark:border-[color:var(--paletteDarkGrayDelimiter)] sticky top-0">
      <div className="flex w-full h-[48px] sm:pl-0 lg:pl-5 sm:justify-center sm:items-center sm:align-middle lg:align-start lg:justify-start">
        <img
          src="/images/sustamizer_logo.svg"
          className={`link h-7 max-md:h-6 cursor-pointer`}
          alt={`sustamize logo`}
          onClick={() => {
            navigate("/");
          }}
        />
      </div>

      {/* Hide button on mobile 
      <a
        href="https://meetings-eu1.hubspot.com/nicolas-carl" // Replace with your desired URL
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:flex" // Button is hidden on mobile (below md)
      >
        <ButtonWrapper
          className="flex items-center space-x-5 ml-4 mr-4 py-1 px-3 mt-2 text-sm h-7 whitespace-nowrap" // Adjusted padding and height
          variant={eButtonVariant.text}
        >
          <span>Book a Demo</span>
          <ArrowForwardIcon fontSize="small" />
        </ButtonWrapper>
      </a>*/}
    </div>
  );
};

export default ApplicationBar;
